import { render, staticRenderFns } from "./ChatDialogWrapper.vue?vue&type=template&id=be64a59c&scoped=true&"
import script from "./ChatDialogWrapper.vue?vue&type=script&lang=js&"
export * from "./ChatDialogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChatDialogWrapper.vue?vue&type=style&index=0&id=be64a59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be64a59c",
  null
  
)

export default component.exports